// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';

export const emailThreadsCountsQuerySchema = z.object({
  queue: idSchema,
});
